module.exports = __webpack_public_path__ + "img/universkin-logo.6b3cc1ce.svg";